// src/context/RemindersContext.js

import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useAuth } from "./AuthContext";

const RemindersContext = createContext();

export const RemindersProvider = ({ children }) => {
  const { user, setUser } = useAuth();
  const { i18n } = useTranslation();
  const [sessionsReminders, setSessionsReminders] = useState([]);
  const [eventsReminders, setEventsReminders] = useState([]);
  const navigate = useNavigate();

  const fetchReminders = async () => {
    if (!user?.token) return;
    try {
      const [sessionsRes, eventsRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/reminders`, {
          params: { type: 2 },
          headers: { lang: i18n.language, Authorization: `Bearer ${user?.token}` },
        }),
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/reminders`, {
          params: { type: 1 },
          headers: { lang: i18n.language, Authorization: `Bearer ${user?.token}` },
        }),
      ]);

      setSessionsReminders(sessionsRes?.data?.data?.data || []);
      setEventsReminders(eventsRes?.data?.data?.data || []);
    } catch (err) {
      if (err.response?.status === 401) {
        // Unauthorized: remove user and redirect to login
        setUser(null);
        navigate("/auth/login", { replace: true });
      } else {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    fetchReminders();
  }, [user?.token, i18n.language]);

  return (
    <RemindersContext.Provider value={{ sessionsReminders, eventsReminders, fetchReminders }}>
      {children}
    </RemindersContext.Provider>
  );
};

export const useReminders = () => useContext(RemindersContext);
